<style scoped>
    .vs-table--tbody-table .tr-values td {
        padding: 3px;
    }
</style>

<template>
<div>
    <div class="w-full vx-col mb-base">
        <vs-card title="Inbound Details" class="p-4 mb-6">
         <div slot="header" class="flex flex-wrap items-center justify-between">
           <div class="flex items-center">
                <vs-button radius color="primary" icon="keyboard_backspace" @click="$router.go(-1)"></vs-button>
                <h4 class="ml-3">Add Inbound</h4>
            </div>
          <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="addInbound" :disabled="inboundItems.length == 0 ? true : false ">Save</vs-button>
        </div>
        <div class="mt-6 vx-row">
            <div class="w-full vx-col lg:w-1/4">
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        Inbound ID*
                    </div>
                    <div class="w-2/3 vx-col">
                        <vs-input class="w-full" v-model="inbound_id" disabled/>
                    </div>
                </div>
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        Inbound Reference*
                    </div>
                    <div class="w-2/3 vx-col">
                        <vs-input class="w-full" v-model="inbound_reference" />
                    </div>
                </div>
                <div class="mt-1 mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        Arrival Date*
                    </div>
                    <div class="w-2/3 vx-col">
                        <flat-pickr class="w-full" v-model="arrival_date" />
                    </div>
                </div>
            </div>
            <div class="w-full vx-col lg:w-1/4">
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        Supplier ID*
                    </div>
                    <div class="w-2/3 vx-col">
                        <vs-select
                            class="selectExample"
                            v-model="supplier_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, customer)"
                            @input="setSelectedSupplier"
                        >
                            <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                        </vs-select>
                    </div>
                </div>
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        &nbsp;
                    </div>
                    <div class="w-2/3 vx-col">
                        <vs-input class="w-full" v-model="supplier_desc_1" disabled />
                    </div>
                </div>
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        &nbsp;
                    </div>
                    <div class="w-2/3 vx-col">
                        <vs-input class="w-full" v-model="supplier_desc_2" disabled />
                    </div>
                </div>
            </div>
            <div class="w-full vx-col lg:w-1/4">
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        Client ID*
                    </div>
                    <div class="w-2/3 vx-col">
                        <vs-select
                            class="selectExample"
                            v-model="client_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, client)"
                            @input="onChangeClient"
                            :disabled="inboundItems.length > 0"
                        >
                            <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                        </vs-select>
                    </div>
                </div>
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        Order Type*
                    </div>
                    <div class="w-2/3 vx-col">
                        <vs-select
                            class="selectExample"
                            v-model="order_type_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, order_type)"
                        >
                            <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                        </vs-select>
                    </div>
                </div>
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        Warehouse*
                    </div>
                    <div class="w-2/3 vx-col">
                        <vs-select
                            class="selectExample"
                            v-model="warehouse_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, warehouse)"
                        >
                            <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                        </vs-select>
                    </div>
                </div>
            </div>
            <div class="w-full vx-col lg:w-1/4">
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        Inbound Status
                    </div>
                    <div class="w-2/3 vx-col">
                    <vs-input class="w-full" v-model="inbound_status" disabled />
                        </div>
                </div>
                <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
                        PO Date
                    </div>
                    <div class="w-2/3 vx-col">
                        <flat-pickr class="w-full" label="PO Date" v-model="po_date" />
                    </div>
                </div>
            </div>
        </div>
        <vs-tabs class="mt-10">
            <vs-tab label="Item Details">
                <vs-button class="mt-5 mr-1 btn" @click="addItem()" :disabled="!client_id" type="border">Add</vs-button>
                <vs-button class="mt-5 mr-1 btn" @click="removeItem()" :disabled="selected.length < 1" type="border">Remove</vs-button>
                <vs-table v-model="selected" :data="inboundItems" hoverFlat class="mt-base" multiple>
                    <template slot="thead">
                        <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                        <vs-th style="min-width: 200px;">Product ID</vs-th>
                        <vs-th style="min-width: 200px;">Description</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Box ID</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Open Qty</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Recv Qty</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                            <vs-td>
                                <vs-input class="w-full" :value="indextr + 1" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.product_id"
                                    width="100%"
                                    @input="onChangeProduct(tr)"
                                    autocomplete
                                    @input-change="searchProductClient($event)"
                                >
                                    <vs-select-item v-for="(item, index) in productOption" :key="index" :value="item.id" :text="item.product_code"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.description" :disabled="true"/>

                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.pack_id" />

                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.batch"/>

                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.box_id"/>

                            </vs-td>
                            <vs-td>
                                <flat-pickr class="w-full" v-model="tr.expired_date"/>

                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.qty" :danger="tr.err" val-icon-danger="clear" :disabled="tr.product_id == '' " @input="Conversion(tr)"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.uom_id"
                                    width="100%"
                                    autocomplete
                                    :disabled="tr.qty == '' || tr.qty == 0 "
                                    @change="Conversion(tr)"
                                    @input="onChangeUom(tr)"
                                >
                                    <vs-select-item v-for="(item, index) in tr.uomOption" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                    <vs-input class="w-full" v-model="tr.open_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                    <vs-input class="w-full" v-model="tr.recv_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                    <vs-input class="w-full" v-model="tr.base_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="tr.base_uom_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="true"
                                    >
                                        <vs-select-item v-for="(item, index) in tr.baseUomOption" :key="index" :value="item.id" :text="item.name"/>
                                    </vs-select>
                                </td>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-tab>
            <vs-tab label="Custom">
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                AJU Number
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="aju_number" />
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                SPPB Number
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="sppb_number" />
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                SPPB Date
                            </div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="sppb_date" />
                            </div>
                        </div>
                        <div class="mt-5 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                BL/AWB
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="blorawb" />
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Registration Number
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="registration_number"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Registration Date
                            </div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="registration_date" />
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Invoice Number
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="invoice_number" />
                            </div>
                        </div>
                    </div>
                </div>
            </vs-tab>
            <vs-tab label="Notes">
                <vs-textarea height="200" class="mt-5" label="Notes" v-model="remark"/>
            </vs-tab>
        </vs-tabs>
        </vs-card>
    </div>
 </div>
</template>

<script type="text/javascript">
    import vSelect from 'vue-select'
    import InboundItem from '@/components/InboundItem.vue'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        name:"inb-create",
        components:{
            vSelect,
            flatPickr,
            InboundItem
        },
        data(){
            return {
                    selected: [],
                    data_conv:0,
                    isLoading:false,
                    inbound_id:'',
                    inbound_reference:'',
                    arrival_date:'',
                    saveState:false,
                    // supplier:
                    // {
                    // 	// id:{
                    // 		id:'',
                    // 		label:'',
                    // 	// },
                    // },
                    supplier_id: null,
                    supplier_desc_1:'',
                    supplier_desc_2:'',
                    inv_type:'FIFO_PICK',
                    inbound_status:'',
                    client_id: this.$store.state.user.userconfig.client_id ? this.$store.state.user.userconfig.client_id : null,
                    old_client_id:this.$store.state.user.userconfig.clients,
                    order_type_id:this.$store.state.user.userconfig.inbound_type_id ? this.$store.state.user.userconfig.inbound_type_id : null,
                    warehouse_id:this.$store.state.user.userconfig.warehouse_id ? this.$store.state.user.userconfig.warehouse_id : null,
                    po_date:'',
                    remark:'',

                    // custom
                    aju_number:'',
                    sppb_number:'',
                    sppb_date:'',
                    blorawb:'',
                    registration_number:'',
                    registration_date:'',
                    invoice_number:'',
                    // end-custom

                    itemList:[],
                    dataItemList:[],
                    clientDDL: null,
                    clientOption: this.$store.state.user.userconfig.client_options,
                    warehouseDDL: null,
                    orderTypeDDL: null,
                    orderTypeOption: [],
                    supplierDDL: {},
                    supplierOptions: [],
                    inboundItems:[],
                    uomOption:[],
                    warehouse: {
                        data: [],
                        loading: false,
                        endpoint: 'master/warehouses',
                        objectKey: 'warehouses_code'
                    },
                    order_type: {
                        data: [],
                        loading: false,
                        endpoint: 'master/ordertypes',
                        objectKey: 'order_type'
                    },
                    client: {
                        data: [],
                        loading: false,
                        endpoint: 'master/clients',
                        objectKey: 'client_code'
                    },
                    customer: {
                        data: [],
                        loading: false,
                        endpoint: 'master/customers',
                        objectKey: 'name'
                    },
                    productOption: []
            }
        },
    watch:{
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    methods:{
        onChangeProduct(value) {
            const product = this.productOption[this.productOption.findIndex(p => p.id == value.product_id)];

            if(product) {
                value.description = product.description_1;
                value.uomOption = [];
                value.baseUomOption = [];

                product.uoms.map(item => {
                    item.uom.numerator = item.numerator
                    item.uom.denominator = item.denominator
                    value.uomOption.push(item.uom);
                })

                value.baseUomOption.push(product.base_uom.uom);
                value.uom_id = product.base_uom.uom.id;
                value.base_uom_id = product.base_uom.uom.id;
                this.onChangeUom(value);
            }
        },
        addItem(){
            let id = this.client_id;

            function getProductbyClient(ax) {
                return ax.post('master/product/showbyclient', { client_id: id });
            }

            if(!this.productOption.length) {
                this.isLoading = true
                this.$http.all([getProductbyClient(this.$http)])
                .then(this.$http.spread((products) => {
                    this.productOption = products.data.data;

                    this.inboundItems.push({
                        line_id:this.generateLineId(),
                        product_id:'',
                        description:'',
                        pack_id:'',
                        batch:'',
                        box_id:'',
                        expired_date:'',
                        uom_id:null,
                        qty:'',
                        base_uom_id:null,
                        open_qty:0,
                        recv_qty:0,
                        base_qty:0,
                        baseUomOption:[],
                        uomOption:[],
                        numerator: 0,
                        denominator: 0,
                        errText:'',
                        err:false,
                    });

                    this.isLoading = false
                }))
            }
            else {
                this.inboundItems.push({
                    line_id:this.generateLineId(),
                    product_id:'',
                    description:'',
                    pack_id:'',
                    batch:'',
                    box_id:'',
                    expired_date:'',
                    uom_id:null,
                    qty:'',
                    base_uom_id:null,
                    open_qty:0,
                    recv_qty:0,
                    base_qty:0,
                    baseUomOption:[],
                    uomOption:[],
                    numerator: 0,
                    denominator: 0,
                    errText:'',
                    err:false,
                });
            }
        },
        validationDetail(data){
            if(this.inbound_status.id > 1){
                 if(this.data_conv < data.recv_qty && data.recv_qty != 0){
                     data.errText = 'qty must be higer than recv qty';
                     data.err = true;
                    console.log('here 1');
                 }else if(this.data_conv >= data.recv_qty && data.recv_qty != 0){
                     let sisa = this.data_conv - data.recv_qty;
                    data.open_qty = sisa ;
                    data.base_qty = this.data_conv;
                    data.errText = '';
                     data.err = false;
                    console.log('here 2');
                 }else if(this.data_conv < data.open_qty && data.recv_qty > 0){
                     data.errText = 'qty cant be lower than open qty';
                     data.err = true;
                    console.log('here 3');
                 }
            }else{
                data.open_qty = this.data_conv ;
                data.base_qty = this.data_conv;
                data.errText = '';
                 data.err = false;
                // console.log('here 4 : '+this.data_conv);
            }
        },
        Conversion : function(data){
            if(data.qty > 0){
                data.base_qty = (data.qty / data.denominator) * data.numerator
                data.open_qty = (data.qty / data.denominator) * data.numerator
                data.err = false;
                data.errText = '';
            }else{
                data.open_qty = 0;
                data.base_qty = 0;
                 data.err = true;
                  data.errText = 'qty must be higer than 0';
            }
        },
        removeItem(index){
            let indexes = []
            this.selected.map(selected => {
                this.inboundItems.map((detail, index) => {
                    if(selected.line_id == detail.line_id) {
                        indexes.push(index)
                    }
                })
            })

            indexes.sort((a, b) => b - a)
            indexes.map(i => this.inboundItems.splice(i, 1))
            this.selected = []

            if(this.inboundItems.length < 1) {
                this.productOption = [];
            }
        },
        onChangeUom(data){
            data.uomOption.map(uom => {
                if(uom.id == data.uom_id) {
                    data.denominator = uom.denominator
                    data.numerator = uom.numerator
                }
            })
                // console.log(JSON.stringify(data));
                  // if(data.qty != ''){
                // 	let cdata = {
                //         'product_id': data.product_id,
                //         'uoms_id': data.uom_id,
                //         'qty': data.qty,
                //       };
                //     this.$http.post('/inbound/conversion', cdata ).then((resp) => {
                //       	// console.log(resp);
                //       	data.base_qty = resp.data;
                //       	data.open_qty = resp.data;
                //     })
                //     .catch((resp) =>{
                //       console.log(resp.response);
                //     });
                // }
              },
        setSelectedSupplier(value) {
            const selected = this.customer.data[this.customer.data.findIndex(customer => customer.id == this.supplier_id)]
            this.supplier_desc_1 = selected.address_1;
            this.supplier_desc_2 = selected.address_2;
         },
         onChangeClient(value){
             if(this.inboundItems.length > 0){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Warning`,
                    text: 'Changing Client ID will be delete All Inbound Items',
                    accept: () => {
                         this.inboundItems = [];
                        this.old_client_id = this.client_id
                    },
                    cancel: () =>{
                        this.client_id = this.old_client_id
                    }
                  })
            }

            const selected = this.client.data[this.client.data.findIndex(customer => customer.id == value)]

            this.inv_type = selected.inv_type
            console.log(this.inv_type)
         },
        generateLineId(){
            return this.inboundItems.length + 1;
        },
         addInbound(){

         if(this.inbound_reference == '' || !this.supplier_id || !this.client_id
         || !this.order_type || !this.warehouse_id || this.req_del_date == '' ){

            this.$vs.notify({
                color: 'danger',
                title: 'Error Header ',
                iconPack: 'feather',
                icon:'icon-x',
                text: 'Please Check Data Inbound Detail'
            })
            return;
         }

        for(let detail of this.inboundItems){
            if(!detail.qty  ||!detail.product_id || !detail.uom_id || detail.err ) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error Item Product',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Check Product Line ' + detail.line_id
                })
                return;
            }

            if(this.inv_type == 'BATCH'){
                    if(detail.batch == ''){
                        this.$vs.notify({
                        color: 'danger',
                        title: 'Error Item Product',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Batch required Product Line ' + detail.line_id
                    })
                    return;
                }
            }

            if(this.inv_type == 'FEFO_PICK'){
                    if(detail.expired_date == ''){
                        this.$vs.notify({
                        color: 'danger',
                        title: 'Error Item Product',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Expired Date required Product Line ' + detail.line_id
                    })
                    return;
                }
            }
        }


             let inbound_head = {
             inbound_reference:this.inbound_reference,
             supplier_id:this.supplier_id,
             client_id:this.client_id,
             order_type_id:this.order_type_id,
             warehouse_id:this.warehouse_id,
             po_date:this.po_date,
             req_del_date:this.arrival_date,
             remark:this.remark,
           };

          let inbound_detail_custom = {
             aju_number:this.aju_number,
             sppb_number:this.sppb_number,
             sppb_date: this.sppb_date,
             blorawb:this.blorawb,
             registration_number:this.registration_number,
             registration_date:this.registration_date,
             invoice_number:this.invoice_number,
           };

           let item_detail = [];

           let data_send = {
            inbound_delivery : inbound_head,
            inbound_delivery_details :this.inboundItems,
            inbound_delivery_custom :inbound_detail_custom,
           };

             this.isLoading = true ;
            this.$http.post('/inbound/inbounddelivery/store', data_send)
            .then((resp) => {
                this.isLoading = false
               // let rstr = JSON.stringify(resp.data);
             this.$vs.notify({
                color: 'success',
                title: 'Succes',
                text: 'Save Succesfully'
              });
             this.$router.push({name:'inbound-delivery-view', params:{id:resp.data.id}});
            })
            .catch((resp) => this.handleError(resp));
         },
         searchProductClient(e) {
            this.$http.post('master/product/showbyclient', { client_id: this.client_id, product_code: e.target.value })
            .then(res => {
                res.data.data.map(item => {
                    if(this.productOption.findIndex(p => p.id === item.id) === -1) {
                        this.productOption.push(item)
                    }
                })
            });
        },
    },
    beforeMount() {
        if(this.isLoading){
            this.$vs.loading()
        }
    },
    mounted(){
        function getClient(ax) {
          return ax.post('/master/clients');
        }
        function getWarehouse(ax) {
          return ax.post('/master/warehouses');
        }

        function getOrderTypes(ax) {
          return ax.post('/master/ordertypes');
        }
        function getCustomers(ax) {
          return ax.post('/master/customers');
        }

        this.isLoading = true;
        // this.isLoading = true
        //         Promise.all([
                    // this.$http.post('master/warehouses'),
        //             this.$http.post('master/clients'),
        //             this.$http.post('master/businesstypes'),
        //             this.$http.post('master/ordertypes'),
        //             this.$http.post('master/transporters'),
        //             this.$http.post('master/servicetypes'),
        //             this.$http.post('master/customers'),
        //             this.$http.post('master/stocktypes'),
        //         ])
        //         .then(this.$http.spread((warehouses, clients, businesstypes, ordertypes, transporters, servicetypes, customers, stocktypes) => {
        //             this.warehouse.data = warehouses.data.data
        //             this.client.data = clients.data.data
        //             this.business_type.data = businesstypes.data.data
        //             this.order_type.data = ordertypes.data.data
        //             this.transporter.data = transporters.data.data
        //             this.service_type.data = servicetypes.data.data
        //             this.customer.data = customers.data.data
        //             this.stock_type.data = stocktypes.data.data
        //             this.isLoading = false
        //         }))
        //         .catch(error => this.handleError(error))
        this.$http.all([getOrderTypes(this.$http), getCustomers(this.$http), this.$http.post('master/warehouses'), this.$http.post('master/clients')])
          .then(this.$http.spread((ordertypes, suppliers, warehouses, clients, customers) => {
                this.order_type.data =  ordertypes.data.data;
                this.customer.data =  suppliers.data.data;
                this.warehouse.data = warehouses.data.data;
                this.client.data = clients.data.data;
                this.isLoading = false
          }))
        .catch((resp) => this.hanleError(resp));
    },
    }
</script>
